import React from 'react';

const PlayCircleFilled = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    {...props}
  >
    <path
      d="M16.9999 2.83331C9.17992 2.83331 2.83325 9.17998 2.83325 17C2.83325 24.82 9.17992 31.1666 16.9999 31.1666C24.8199 31.1666 31.1666 24.82 31.1666 17C31.1666 9.17998 24.8199 2.83331 16.9999 2.83331ZM14.1666 23.375V10.625L22.6666 17L14.1666 23.375Z"
      fill="white"
    />
  </svg>
);

export default PlayCircleFilled;
